// import React from "react";
// import { Box, Container, Typography } from "@mui/material";

// const brandLogos = [
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_7.svg",
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_6.svg",
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_5.svg",
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_4.svg",
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_3.svg",
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_2.svg",
//   "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_1.svg",
// ];

// const TrustedSection = () => {
//   return (
//     <>
//       {/* keyframes for the auto-moving carousel */}
//       <style>{`
//         @keyframes brandScroll {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//       `}</style>

//       <Box
//         sx={{
//           py: 6,
//           bgcolor: "#fafafa",
//         }}
//       >
//         <Box>
//           {/* Heading */}
//           <Typography
//             align="center"
//             sx={{
//               fontSize: 20,
//               fontWeight: 500,
//               mb: 4,
//             }}
//           >
//             Trusted by over{" "}
//             <Box component="span" sx={{ color: "#287bff", fontWeight: 700 }}>
//               90k+
//             </Box>{" "}
//             companies worldwide
//           </Typography>

//           {/* Carousel */}
//           <Box
//             sx={{
//               position: "relative",
//               overflow: "hidden",
//               width: "100%",
//               height: 90,
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 columnGap: { xs: 6, md: 12 },
//                 width: "max-content",
//                 animation: "brandScroll 25s linear infinite",
//                 opacity: 0.85,
//               }}
//             >
//               {/* duplicate logos so the animation loops seamlessly */}
//               {[...brandLogos, ...brandLogos].map((src, index) => (
//                 <Box
//                   key={index}
//                   component="img"
//                   src={src}
//                   alt={`Brand logo ${index + 1}`}
//                   sx={{
//                     height: 48,
//                     width: "auto",
//                     flexShrink: 0,
//                     filter: "grayscale(100%)",
//                   }}
//                 />
//               ))}
//             </Box>
//           </Box>
//         </Box>
//       </Box>
//     </>
//   );
// };

// export default TrustedSection;



import React from "react";
import { Box, Container, Typography } from "@mui/material";

const brandLogos = [
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_7.svg",
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_6.svg",
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_5.svg",
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_4.svg",
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_3.svg",
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_2.svg",
  "https://html.themehour.net/kleanix/demo/assets/img/brand/brand_1_1.svg",
];

const TrustedSection = () => {
  return (
    <>
      <style>{`
        @keyframes brandScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>

      {/* light gray band */}
      <Box
        sx={{
          bgcolor: "#f6f7f9",
          pt: 6,
          pb: 10,               // extra bottom space for the overlapping card
        }}
      >
        <Box>
          {/* heading */}
          <Typography
            align="center"
            sx={{
              fontSize: 20,
              fontWeight: 500,
              mb: 4,
            }}
          >
            Trusted by over{" "}
            <Box component="span" sx={{ color: "#287bff", fontWeight: 700 }}>
              90k+
            </Box>{" "}
            companies worldwide
          </Typography>

          {/* auto-moving carousel */}
          <Box
            sx={{
              position: "relative",
              overflow: "hidden",
              width: "100%",
              height: 90,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                columnGap: { xs: 6, md: 12 },
                width: "max-content",
                animation: "brandScroll 25s linear infinite",
                opacity: 0.85,
              }}
            >
              {[...brandLogos, ...brandLogos].map((src, index) => (
                <Box
                  key={index}
                  component="img"
                  src={src}
                  alt={`Brand logo ${index + 1}`}
                  sx={{
                    height: 48,
                    width: "auto",
                    flexShrink: 0,
                    filter: "grayscale(100%)",
                  }}
                />
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TrustedSection;
